import useCrud from '../useCrud'

const useCoordinatorCount = () => {
  const { get: getCoordinatorCount } = useCrud('/admin/v1/users/coordinator_count')

  return { getCoordinatorCount }
}

export default useCoordinatorCount
